<template>
  <div class="viewSetteleScanInfo">
    <el-drawer
      size="70%"
      title="查看电子结算卡"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
    >
      <!-- <basic-container> -->
      <div class="info">
        <avue-crud
          ref="cruds"
          :data="tableData"
          :table-loading="tableLoading"
          :option="tableOption"
          v-model="form"
          @on-load="getPage"
        >
          <template slot="menu" slot-scope="{ row }">
            <el-button type="text" size="small" plain @click="lookWaybill(row)">
              查看可结算运单</el-button
            >
          </template>
        </avue-crud>
        <div class="line"></div>
        <avue-crud
          ref="cruds"
          :data="tableData1"
          :option="tableOption1"
          :cell-style="cellStyle"
        >
        </avue-crud>
        <!-- <el-descriptions>
          <el-descriptions-item label="交卡回执单号">{{
            info.giveCardNo
          }}</el-descriptions-item>
          <el-descriptions-item label="交卡总数">{{
            info.cardCount
          }}</el-descriptions-item>
          <el-descriptions-item label="运单总数">{{
            info.giveCardCnt
          }}</el-descriptions-item>
          <el-descriptions-item label="可结算运单数">{{
            info.settleAbleCount
          }}</el-descriptions-item>
          <el-descriptions-item label="交卡时间">{{
            info.giveCardDatetime
          }}</el-descriptions-item>
          <el-descriptions-item label="交卡人">{{
            info.giveCardUserId
          }}</el-descriptions-item>
        </el-descriptions> -->
      </div>

      <!-- </basic-container> -->
    </el-drawer>
    <waybill
      v-if="waybillVisible"
      :isHistory="true"
      :cardNo="curCardNo"
      :giveCardNo="info.giveCardNo"
      :visible.sync="waybillVisible"
    ></waybill>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { selectWaybillsGiveNoGenerated } from "@/api/chain/companysettle";
import { expotOut } from "@/util/down.js";
import waybill from "./waybill.vue";

export default {
  components: {
    waybill,
  },
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      cellStyle: ({ row, column, rowIndex, columnIndex }) => {
        if (columnIndex == 0 || columnIndex == 2) {
          return {
            background: "#F5F8FA",
          };
        }
      },
      form: {},
      tableData: [],
      btnLoading: false,
      paramsSearch: {},
      tableLoading: false,
      tableOption1: {
        menu: false,
        showHeader: false,
        border: true,
        column: [
          {
            label: "",
            prop: "label1",
            width: 150,
            classname: "active-label",
          },
          {
            label: "",
            prop: "value1",
          },
          {
            label: "",
            prop: "label2",
            width: 150,
            class: "active-label",
          },
          {
            label: "",
            prop: "value2",
          },
        ],
      },
      tableData1: [],
      tableOption: {
        dialogDrag: false,
         border: true,
        indexLabel: "序号",
        stripe: false,
        searchShow: false,
        labelWidth: 150,
        searchLabelWidth: 80,
        searchSpan: 12,
        excelBtn: false,
        printBtn: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        searchMenuSpan: 6,
        index: false,
        refreshBtn: false,
        menuWidth: 140,
        defaultSort: {
          prop: "purchaseDate",
          order: "ascending",
        },
        column: [
          {
            label: "电子结算卡号码",
            prop: "settleCardNo",
            width: 150,
          },
          {
            label: "卡类型",
            prop: "cardType",
          },
          // {
          //   label: "项目名称",
          //   prop: "projectName",
          // },
          {
            label: "运单总数",
            prop: "giveCardCnt",
            width: 150,
          },
          {
            label: "可结算运单数",
            prop: "settleAbleCount",
          },
        ],
      },
      curCardNo: "",
      waybillVisible: false,
    };
  },
  created() {},
  mounted: function () {
    this.tableData1 = [
      {
        label1: "交卡回执单号",
        value1: this.info.giveCardNo,
        label2: "交卡总数",
        value2: this.info.cardCount,
      },
      {
        label1: "运单总数",
        value1: this.info.giveCardCnt,
        label2: "可结算运单数",
        value2: this.info.settleAbleCount,
      },
      {
        label1: "交卡时间",
        value1: this.info.giveCardDatetime,
        label2: "交卡人",
        value2: this.info.giveCardUserId,
      },
    ];
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    cancelModal() {
      this.$emit("update:visible", false);
    },

    getPage(params = {}) {
      this.tableLoading = true;
      selectWaybillsGiveNoGenerated(
        Object.assign(
          {
            giveCardNo: this.info.giveCardNo,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    lookWaybill(item) {
      this.curCardNo = item.settleCardNo;
      this.waybillVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__header {
  // margin-bottom: 10px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ededf0;
}
.info {
  margin: 32px;
  margin-top: 0;
  border: 1px solid #edeff0;
  min-height: 634px;
}
/deep/.avue-crud__menu {
  display: none;
}
.line {
  height: 2px;
  background: #999999;
  margin-bottom: 20px;
}
/deep/.active-label {
  background: #f5f8fa;
  font-weight: 400;
  font-size: 14px;
  color: #313133;
}
/deep/ .el-table__header th.is-leaf {
  background: #f5f8fa!important;
}
</style>
